module.exports = "/_next/static/images/game-1-phone-gallery-08-23-1500-f13d0ce4194ea65311ea329c82b9763a.jpg";